import React from 'react';

const Heart = () => {
  const iconColor = process.env.GATSBY_STORE === 'MPS' ? 'var(--primary-default)' : 'currentColor';
  return (
    <svg
      width="18"
      height="16"
      viewBox="0 0 18 16"
      fill={iconColor}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.63582 8.038L8.99792 14.4001L15.36 8.038C16.0673 7.33076 16.4646 6.37153 16.4646 5.37133C16.4646 3.28854 14.7761 1.6001 12.6933 1.6001C11.6932 1.6001 10.7339 1.99742 10.0267 2.70467L8.99792 3.73343L7.96915 2.70467C7.26191 1.99742 6.30268 1.6001 5.30249 1.6001C3.21969 1.6001 1.53125 3.28854 1.53125 5.37133C1.53125 6.37153 1.92857 7.33075 2.63582 8.038Z"
        stroke={iconColor}
        strokeWidth="1.5"
        strokeLinejoin="round"
      />
    </svg>
  )
};

export default Heart;
